var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 6.33333C2.68696 6.33333 3.02609 6.47381 3.27614 6.72386C3.52619 6.97391 3.66667 7.31304 3.66667 7.66667V9H10.3333V7.66667C10.3333 7.31304 10.4738 6.97391 10.7239 6.72386C10.9739 6.47381 11.313 6.33333 11.6667 6.33333M2.33333 6.33333C1.97971 6.33333 1.64057 6.47381 1.39052 6.72386C1.14048 6.97391 1 7.31304 1 7.66667V10.3333C1 10.687 1.14048 11.0261 1.39052 11.2761C1.64057 11.5262 1.97971 11.6667 2.33333 11.6667H11.6667C12.0203 11.6667 12.3594 11.5262 12.6095 11.2761C12.8595 11.0261 13 10.687 13 10.3333V7.66667C13 7.31304 12.8595 6.97391 12.6095 6.72386C12.3594 6.47381 12.0203 6.33333 11.6667 6.33333M2.33333 6.33333V3C2.33333 2.46957 2.54405 1.96086 2.91912 1.58579C3.29419 1.21071 3.8029 1 4.33333 1H9.66667C10.1971 1 10.7058 1.21071 11.0809 1.58579C11.456 1.96086 11.6667 2.46957 11.6667 3V6.33333M3 11.6667V13M11 11.6667V13",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.60f3014efd850c1ef33a38a65f781f4a.svg";
export { ForwardRef as ReactComponent };